import { Stack, Typography } from "@mui/material";

import { LegendCard } from "@/Components/v2/atoms/Card";
import { ColoredCircle } from "@/Components/v2/atoms/ColoredCircle";

export interface SatCurveLegendCardData {
  key: string;
  label: string;
  color: string;
  spend: string;
  revenue: string;
}

interface LegendCardProps {
  legend: SatCurveLegendCardData;
}

export const SatCurveLegendCard: React.FC<LegendCardProps> = ({ legend }) => {
  const { revenue, spend } = legend;

  return (
    <LegendCard sx={{ width: "100%", boxShadow: "none" }}>
      <Stack direction="row" spacing={1} paddingBottom={1} alignItems="center">
        <ColoredCircle color={legend.color} />
        <Typography fontWeight={600}>{legend.label}</Typography>
      </Stack>
      <Typography variant="caption" color="textSecondary">
        Weekly spend
      </Typography>
      <Typography variant="body1" fontWeight={600} sx={{ marginBottom: 1 }}>
        {spend}
      </Typography>
      <Typography variant="caption" color="textSecondary">
        Expected weekly revenue
      </Typography>
      <Typography variant="body1" fontWeight={600}>
        {revenue}
      </Typography>
    </LegendCard>
  );
};
